import { MAIN_COMPANY } from '../../../_CORE/_RuntimeConfig/MainCompany.js';
import { LAYOUTS } from '../../../_CORE/_RuntimeConfig/_Config/_Layouts.js';
import { APP__PLUGINS } from '../../../_CORE/_RuntimeConfig/_Config/Plugins.js';
import { APP_MODULES_GET_PUBLIC_ROUTES, APP_MODULES_GET_PRIVATE_ROUTES } from '../AppModules.js';
import { LoopyLandingPage } from '../Landing/LoopyLandingPage.js';

const PUBLIC_ROUTES = [
    {
        path: '/', label: 'Inicio', component: <LoopyLandingPage />, isBlockedWhenLogged: false,
        displayInHeader: true, displayInFooter: false, displayInSidebar: false,
    },
    ...APP_MODULES_GET_PUBLIC_ROUTES(),
];

const PRIVATE_ROUTES = [
    ...APP_MODULES_GET_PRIVATE_ROUTES(),
];

const HEADER_UTILITIES = [
    { id: 'carts', isEnabled: APP__PLUGINS.HAS_CART === true, requiresAuth: false, hideWhenAuth: false },
    { id: 'favs', isEnabled: APP__PLUGINS.HAS_FAVS === true, requiresAuth: true, hideWhenAuth: false },
    { id: 'messages', isEnabled: APP__PLUGINS.HAS_CHAT_MESSAGES === true, requiresAuth: true, hideWhenAuth: false },
    { id: 'messages_email', isEnabled: APP__PLUGINS.HAS_CHAT_EMAIL === true, requiresAuth: true, hideWhenAuth: false },
    { id: 'messages_whatsapp', isEnabled: APP__PLUGINS.HAS_CHAT_WHATSAPP === true, requiresAuth: true, hideWhenAuth: false },
    { id: 'language', isEnabled: APP__PLUGINS.HAS_LANGUAGES === true, requiresAuth: false, hideWhenAuth: false },
    { id: 'theme', isEnabled: MAIN_COMPANY.APP_HAS_THEME_MODE !== false, requiresAuth: false, hideWhenAuth: false },
    { id: 'notifications', isEnabled: APP__PLUGINS.HAS_NOTIFICATIONS === true, requiresAuth: true, hideWhenAuth: false },
    { id: 'profile', isEnabled: APP__PLUGINS.HAS_PROFILE === true, requiresAuth: true, hideWhenAuth: false },
    { id: 'auth_login', isEnabled: APP__PLUGINS.HAS_AUTH_USER_SIMPLE === true, requiresAuth: false, hideWhenAuth: true },
];

export const APP_LAYOUT_STRUCTURE = Object.freeze({
    brand: {
        name: MAIN_COMPANY.APP_NAME || MAIN_COMPANY.COMPANY_NAME || 'APP',
        claim: MAIN_COMPANY.APP_DESCRIPTION || '',
        logoDark: MAIN_COMPANY.APP_LOGO_DARK || '', logoLight: MAIN_COMPANY.APP_LOGO_LIGHT || '',
    },

    ui: {
        headerPublic: true, footerPublic: false,
        headerPrivate: true, footerPrivate: true, sidebarPrivate: true,
    },

    languages: [
        { code: MAIN_COMPANY.APP_LANGUAGE || 'es', label: 'Español' },
    ],

    loginLabel: 'Ingresar', portalLabel: 'Portal', showBrandLS: true,
    publicRoutes: PUBLIC_ROUTES, privateRoutes: PRIVATE_ROUTES,
    utilities: HEADER_UTILITIES,

    utilityLinks: {
        carts: '/cart', favs: '/favorites', messages: '/messages', messages_email: '/messages/email',
        messages_whatsapp: '/messages/whatsapp', notifications: '/notifications', auth_login: '/login', auth_portal: '/portal',
    },

    guards: {
        isEnabled: APP__PLUGINS.HAS_AUTH_USER_SIMPLE === true || APP__PLUGINS.HAS_AUTH_USER_PORTAL_ROL === true || APP__PLUGINS.HAS_AUTH_USER_PORTAL_CLIENT === true,
        loginPath: '/login', forbiddenPath: '/forbidden', afterLoginPath: '/', guestEntryPath: '/',
        guestOnlyPaths: ['/login', '/register', '/forgot-password'],
    },

    config: LAYOUTS,
});

export const onResolveLayoutNavigation = (user = null, language = MAIN_COMPANY.APP_LANGUAGE || 'es') => ({
    claim: APP_LAYOUT_STRUCTURE.brand.claim, language, user,
    publicRoutes: APP_LAYOUT_STRUCTURE.publicRoutes,
    privateRoutes: APP_LAYOUT_STRUCTURE.privateRoutes,
    publicNav: APP_LAYOUT_STRUCTURE.publicRoutes.filter((item) => item.displayInHeader !== false && item.isHiddenFromNavigation !== true),
    profileLinks: [], footerColumns: [], footerColumnsPrivate: [], legal: `© ${MAIN_COMPANY.COMPANY_NAME || MAIN_COMPANY.APP_NAME || 'Loopy Studios'} · 2025–${new Date().getFullYear()}. Todos los derechos reservados.`,
});
